import React from 'react';

// SmartRoute component - redirects removed
// Now simply renders children without any redirect logic
const SmartRoute = ({ children, path }) => {
  // No redirects - just render children
  return children;
};

export default SmartRoute;
